export default {
  message: {
    btnLogin: 'Login',
    btnLogout: 'Logout',
    logged_in_as: 'Logged in as',
    description: 'Description',
    save: 'Save',
    search: 'Search',
    cancel: 'Cancel',
    delete: 'Delete',
    close: 'Close',
    deleteConfirm: 'Are you sure you want to delete "{name}" ?',
    select: 'Select',
    contains: 'Contains',
    selected: 'Selected',
    please_select: 'Please Select',
    open: 'Open',
    add: 'Add',
    clone: 'Clone',
    refresh: 'Refresh status',
    switch_admin_layout: 'Switch to admin layout',
    switch_user_layout: 'Switch to user layout',
    turn_on_admin_layout: 'Turn on admin layout',
    turn_off_admin_layout: 'Turn off admin layout',
    change_layout: 'Change layout',
    dashboard: {
      close: 'Close',
      redial: 'Re-dial',
      captioners: 'Captioners',
      status: 'Status',
      busy: 'Busy',
      not_busy: 'Not busy',
      call: 'Call',
      on_call: 'On a call',
      hang_up: 'Hang up',
      enter_number: 'Enter number',
      conversation: 'Conversation',
      dashboard: 'Dashboard',
      admin_dashboard: 'Admin Dashboard',
      past_calls: "Past Conversations",
      there_is_no_number: 'There is no such number.',
      there_is_no_conversation: 'There is no conversation.',
      there_is_no_bridge: 'There is no bridge with this number.',
      empty_value: 'Please enter valid number',
      create_new_conversation: 'Create new bridge',
      auto_join: "Auto join",
      join: "Join",
      no_records: 'There are no records',
      refresh_bridges: 'Refresh bridges',
      adminDashboard: {
        terminate_conv: 'Terminate bridge',
        connect: 'Connect',
        manage_calls: 'Manage bridges',
        history: 'History',
        manage_users: 'Manage users',
      },
      searchNumber: {
        no_results: 'No Conversations found',
        search_number: 'Search by number',
        search_number_or_name: 'Search by number or name',
        search_bridge_by_number: 'Search bridge by number'
      },
      editUser: {
        select: 'Select',
        edit_user: 'Edit User',
        add_user: 'Add User',
        confirm_delete: 'Are you sure you want to delete "{userName}" ?',
        delete_user: 'Delete User',
        role: 'Role',
        admin: 'Administrator',
        user: 'User',
        number: 'Number',
        name: 'Name'
      },
    },
    login: {
      loginTo2: 'Login to NCI Connect',
      loginTo: 'Login to',
      btnLogin: 'Open authentication popup...',
      description: 'If the popup does not show make sure to allow popups from this site.',
      loginFailed: 'Login Failed',
      error: 'Could not authenticate you because {error}',
      error2: 'Login failed.',
      error3: 'Invalid number',
      error4: 'Invalid code',
      inputLabel: "Please enter valid number",
      inputLabel2: "Please enter verification code",
      submit: "Send me verification code",
      verify_code: "Verify code"
    },
    homePage: {
      home: 'Home',
    },
    admin: {
      admin_dashboard: 'Admin dashboard',
      manage: 'Manage...',
      created_at: 'Created At',
      created_by: 'Created By',
      updated_at: 'Updated At',
      updated_by: 'Updated By',
    },
    errors: {
      errorRequiredField: 'This field is required',
      not_selected_option: 'Please check at least one of the displayed options',
      failed_to_fetch: 'Failed to fetch!',
      failed_to_edit: 'Failed to edit!',
      failed_to_add: 'Failed to add!',
      failed_to_delete: 'Failed to delete!',
      failed_to_clone: 'Failed to clone!',
      name_already_taken: 'Name already taken!',
      duplicate_entry: '{resource} with name "{name}" already exists!',
      bridge_error: 'Bridge changed, please reload to review the bridge.',

      PHONE_UNAUTHORIZED: {
        title: 'Number Not Authorized',
        text: 'Contact your IT department to use this number with NCI Connect.',
      },
      PHONE_NOT_ALLOWED: {
        title: 'Number is not allowed',
        text: '',
      },
      VERIFICATION_FAILED: {
        title: 'Wrong code',
        text: 'Please enter your code again.',
      },
      VERIFICATION_EXPIRED: {
        title: 'Your code has expired.',
        text: 'Try with a new one.',
      },
      INVALID_VERIFICATION_CODE: {
        title: 'Invalid code',
        text: '',
      },

      EXPIRED_REFRESH_TOKEN : {
        title: 'Your session has expired.',
        text: 'Please login again',
      },
      OTHER: {
        title: 'Sending code failed',
        text: 'Please try again later or contact your IT department.',
      },
      UNSUPPORTED_NEXMO_NETWORK: {
        title: '',
        text: '',
      },
      NEXMO_VERIFICATION_IN_PROGRESS: {
        title: '',
        text: '',
      },
      INCORRECT_FORMAT: {
        title: 'The phone number is invalid',
        text: '',
      },
      JWT_NOT_VERIFIED: {
        title: '',
        text: '',
      },
      UNKNOWN_TOKEN_PAIR: {
        title: '',
          text: '',
      },
      REQUEST_ERROR: {
        title: '',
        text: '',
      },
      EXPIRED_JWT: {
        title: 'Access token has expired',
        text: '',
      },
    },
  },
};
